import sistemaAnotacoes from "../../assets/capaProjetos/sistemaAnotacoes.png";
import portfolioHTMLCSS from "../../assets/capaProjetos/portfolio.png";
import agenciaDeViagens from "../../assets/capaProjetos/CRUDagenciaViagens.png";
import healing from "../../assets/capaProjetos/healing.png";
import passIn from "../../assets/capaProjetos/passIn.png";
import timeWise from "../../assets/capaProjetos/timeWise.png";
import bancoDeTalentos from "../../assets/capaProjetos/bancoTalentos.jpg";
import gerencEstoque from "../../assets/capaProjetos/gerencEstoque.jpg";
import jogoDaVelha from "../../assets/capaProjetos/jogoDaVelha.jpg";
import gerencBiblioteca from "../../assets/capaProjetos/biblioteca.jpg";
import gerencPetShop from "../../assets/capaProjetos/petshop.jpg";
import jogoXadrez from "../../assets/capaProjetos/xadrez.jpg";
import superTrunfoGenshin from "../../assets/capaProjetos/superTrunfo.jpg";
import aluraFlix from "../../assets/capaProjetos/aluraFlix.png";

const createData = (translations) => [
  {
    title: translations.project23Title,
    date: translations.project23Date,
    description: translations.project23Desc,
    technology: "HTML, CSS, JS, NodeJS",
    link: "https://github.com/codinGloria/sistemaAnotacoes",
    image: sistemaAnotacoes
  },
  {
    title: translations.project22Title,
    date: translations.project22Date,
    description: translations.project22Desc,
    technology: "HTML, CSS, JS",
    link: "https://github.com/codinGloria/portfolioHTMLCSS",
    image: portfolioHTMLCSS
  },
  {
    title: translations.project21Title,
    date: translations.project21Date,
    description: translations.project21Desc,
    technology: "Java, Spring Boot, PostgreSQL"
  },
  {
    title: "20. Plann.er",
    date: translations.project20Date,
    description: translations.project20Desc,
    technology: "Java, React",
    link: "https://github.com/codinGloria/nlwJourney-planner"
  },
  {
    title: "19. Portfolio",
    date: translations.project19Date,
    description: translations.project19Desc,
    technology: "React"
  },
  {
    title: translations.project18Title,
    date: translations.project18Date,
    description: translations.project18Desc,
    technology: "Java, Spring Boot",
    link: "https://github.com/codinGloria/CRUDagenciaViagens",
    image: agenciaDeViagens
  },
  {
    title: "17. Healing",
    date: translations.project17Date,
    description: translations.project17Desc,
    technology: "Python, Django",
    link: "https://github.com/codinGloria/psw10-Healing",
    image: healing
  },
  {
    title: "16. PassIn",
    date: translations.project16Date,
    description: translations.project16Desc,
    technology: "Java, React",
    link: "https://github.com/codinGloria/nlwUnite-PassIn",
    image: passIn
  },
  {
    title: "15. TimeWise",
    date: translations.project15Date,
    description: translations.project15Desc,
    technology: "Java, Angular",
    link: "https://github.com/codinGloria/projectTimeWise",
    image: timeWise
  },
  {
    title: translations.project14Title,
    date: translations.project14Date,
    description: translations.project14Desc,
    technology: "Java, JPA e Hibernate",
    link: "https://github.com/codinGloria/academiaJava/tree/main/aula28/Labs",
    image: bancoDeTalentos
  },
  {
    title: translations.project13Title,
    date: translations.project13Date,
    description: translations.project13Desc,
    technology: "Java, JavaFX",
    link: "https://github.com/codinGloria/gerenciamentoEstoque",
    image: gerencEstoque
  },
  {
    title: translations.project12Title,
    date: translations.project12Date,
    description: translations.project12Desc,
    technology: "HTML, CSS, JS",
    link: "https://mini-site-liviabraz.vercel.app/"
  },
  {
    title: translations.project11Title,
    date: translations.project11Date,
    description: translations.project11Desc,
    technology: "HTML, CSS, JS",
    link: "https://github.com/codinGloria/jogoDaVelha",
    image: jogoDaVelha
  },
  {
    title: translations.project10Title,
    date: translations.project10Date,
    description: translations.project10Desc,
    technology: "Java, JOption",
    link: "https://github.com/codinGloria/academiaJava/tree/main/aula06/labs/biblioteca",
    image: gerencBiblioteca
  },
  {
    title: translations.project9Title,
    date: translations.project9Date,
    description: translations.project9Desc,
    technology: "Java, JOption",
    link: "https://github.com/codinGloria/academiaJava/tree/main/aula07/labs/PetShop",
    image: gerencPetShop
  },
  {
    title: translations.project8Title,
    date: translations.project8Date,
    description: translations.project8Desc,
    technology: "Java",
    link: "https://github.com/codinGloria/cursoJavaUdemy/tree/main/Se%C3%A7%C3%A3o%2016%20-%20PROJETO%20-%20Sistemas%20jogo%20de%20xadrez/src",
    image: jogoXadrez
  },
  {
    title: translations.project7Title,
    date: translations.project7Date,
    description: translations.project7Desc,
    technology: "HTML, CSS, JS",
    link: "https://github.com/codinGloria/imersaoDevAlura"
  },
  {
    title: translations.project6Title,
    date: translations.project6Date,
    description: translations.project6Desc,
    technology: "HTML, CSS, JS",
    link: "https://github.com/codinGloria/superTrunfoGenshin",
    image: superTrunfoGenshin
  },
  {
    title: translations.project5Title,
    date: translations.project5Date,
    description: translations.project5Desc,
    technology: "HTML, CSS, JS",
    link: "https://github.com/codinGloria/imersaoDevAlura"
  },
  {
    title: translations.project4Title,
    date: translations.project4Date,
    description: translations.project4Desc,
    technology: "HTML, CSS, JS",
    link: "https://github.com/codinGloria/imersaoDevAlura"
  },
  {
    title: translations.project3Title,
    date: translations.project3Date,
    description: translations.project3Desc,
    technology: "HTML, CSS, JS",
    link: "https://github.com/codinGloria/imersaoDevAlura"
  },
  {
    title: "2. AluraFlix",
    date: translations.project2Date,
    description: translations.project2Desc,
    technology: "HTML, CSS, JS",
    link: "https://github.com/codinGloria/aluraFlix",
    image: aluraFlix
  },
  {
    title: translations.project1Title,
    date: translations.project1Date,
    description: translations.project1Desc,
    technology: "HTML, CSS, JS",
    link: "https://github.com/codinGloria/imersaoDevAlura"
  }
];

export default createData;